import { Controller } from "@hotwired/stimulus"
import { isInIframe } from "lib/utilities";
import { useElementListener } from "lib/event_helpers";
import ahoy from "ahoy.js";

export default class extends Controller {
  static broadcastListenerAdded = false;
  static targets = ["messageContent"];
  static values = { messageUuid: String };
  static dispatchedMessageUuids = new Set();

  // Announces when new assistant messages are added to DOM
  // Including when on first load
  // Checks for data-newest on element which is only from partials
  connect() {
    if (this.hasMessageUuidValue && this.element.classList.contains("data-newest")) {
      if (!this.isMessageUuidDispatched()) {
        this.dispatch("new", { detail: { content: this.element.innerHTML } });
        this.addDispatchedMessageUuid(); // so we don't dispatch again
      } else {
        this.dispatch("update")
      }

      // Remove the `data-newest` class whenever it gets re-added
      this.element.classList.remove("data-newest");
    }

    if(this.hasMessageContentTarget) {
      this.messageContentTarget.querySelectorAll("a[href]:not([data-action])").forEach(el => {
        useElementListener(this, el, "click", this.logLinkClick);
      });
    }

    if (!this.constructor.broadcastListenerAdded) {
      this.onBroadcastComplete();
      this.constructor.broadcastListenerAdded = true; // so we don't repeat it
    }
  }

  onBroadcastComplete() {
    document.addEventListener("chat--broadcast:complete", (event) => {
      // Reveal rating per message
      const domId = `message-${event.detail.content.uuid}_rating`;
      const ratingElement = document.getElementById(domId);
      if (ratingElement) {
        ratingElement.style.display = "flex";
      }

      // if not iframe, allow copy text. Resolve when we can set permissions on iframe
      // <iframe allow="clipboard-read; clipboard-write"></iframe>
      // if (!isInIframe()) {
      //   // Enable copy text
      //   const copyElements = event.detail.content.element.querySelectorAll(".message-content");
      //   copyElements.forEach(el => {
      //     el.setAttribute("data-action", "click->chat--copy#copyText");
      //   })
      // }
    })
  }

  onCollapseShow() {
    // Invoked when the citations Boostrap.Toggle starts to animate —
    // we want to forward this event from our _citations partial
    // to our window
    this.dispatch('collapse-show', { detail: { message: this.element } })
  }

  onCollapseShown() {
    // Invoked when the citations Boostrap.Toggle stops animating —
    // we want to forward this event from our _citations partial
    // to our window
    this.dispatch('collapse-shown', { detail: { message: this.element } })
  }

  isMessageUuidDispatched() {
    return this.constructor.dispatchedMessageUuids.has(this.messageUuidValue);
  }

  addDispatchedMessageUuid() {
    this.constructor.dispatchedMessageUuids.add(this.messageUuidValue);
  }

  logLinkClick(event) {
    let source = isInIframe() ? "iframe" : "direct";
    let eventName = "MessageLinkClick";
    let linkText = event.target.innerText;
    let href = event.target.href;

    ahoy.track(eventName, {
      linkText: linkText,
      href: href,
      source: source,
      organization: this.application.dewey?.organization?.name,
      organization_id: this.application.dewey?.organization?.id,
      user_id: this.application.dewey?.user?.id
    });
  }
}